<!--
    描述：规则设置页面
    时间：2021-09-24
    Created by 王帅
-->
<template>
    <div class="w-page-main">
        <div class="w-page-header">
            <!-- 带保存按钮 -->
            <template v-if="needSave">
                <div class="left-text">
                    请选择分析规则
                    <el-select
                            class="ml10"
                            size="small"
                            v-model="curRule"
                            @change="onChangeRule"
                    >
                        <el-option
                                v-for="(item, index) in rulesList"
                                :key="'规则' + index"
                                :value="item.id"
                                :label="item.sname"
                        ></el-option>
                    </el-select>
                </div>
                <div class="btn-groups" v-if="needSave && showTools">
                    <el-button size="small" type="primary" @click="onClickSave"
                    >保存规则
                    </el-button
                    >
                    <el-button size="small" type="danger" @click="onClickDelete" v-if="ruleObj.isSys !== 1"
                    >删除规则
                    </el-button>
                </div>
            </template>

            <!-- 无需保存按钮 -->
            <template v-else>
                <div class="left-text">清单分析</div>
            </template>
        </div>
        <div class="w-page-container" v-loading="tableLoading">
            <vxe-table
                    border
                    highlight-hover-row
                    ref="xTable"
                    :data="tableData"
                    auto-resize
                    resizable
                    height="535px"
                    align="center"
            >
                <vxe-column type="seq" width="60" title="序号"></vxe-column>
                <vxe-column width="60" title="操作" field="tool">
                    <template #default="{ row }">
                        <vxe-button
                                size="mini"
                                status="primary"
                                type="text"
                                @click="doClear(row.order)"
                        >清空
                        </vxe-button
                        >
                    </template>
                </vxe-column>
                <vxe-column
                        field="title"
                        title="分析项"
                        width="130"
                        header-align="center"
                        align="left"
                ></vxe-column>
                <vxe-column
                        field="sname"
                        title="异常条件"
                        header-align="center"
                        align="left"
                >
                    <template #default="{ row }">
                        <!-- 清单名称是否一致 -->
                        <template v-if="row.order === 1">
                            <vxe-checkbox
                                    v-model="rules.sname"
                                    :checked-value="1"
                                    :unchecked-value="0"
                                    :disabled="mode === 'view'"
                                    content="文字不一致"
                            ></vxe-checkbox>
                        </template>

                        <!-- 清单特征是否一致 -->
                        <template v-if="row.order === 2">
                            <vxe-checkbox
                                    v-model="rules.feature"
                                    :checked-value="1"
                                    :unchecked-value="0"
                                    :disabled="mode === 'view'"
                                    content="文字不一致"
                            ></vxe-checkbox>
                        </template>

                        <!-- 清单单位是否一致 -->
                        <template v-if="row.order === 3">
                            <vxe-checkbox
                                    v-model="rules.unit"
                                    :checked-value="1"
                                    :unchecked-value="0"
                                    :disabled="mode === 'view'"
                                    content="文字不一致"
                            ></vxe-checkbox>
                        </template>

                        <!-- 清单工程量 -->
                        <template v-if="row.order === 4">
                            <div class="flex-row">
                                <!-- 单项选择 -->
                                <div class="radio-box">
                                    <vxe-radio-group v-model="rules.quantities.type" :disabled="mode === 'view'"
                                                     @change="handleChangeType($event, 'quantities')">
                                        <vxe-radio
                                                :label="0"
                                                content="数值不一致"
                                        ></vxe-radio>
                                        <vxe-radio
                                                :label="1"
                                                content="数量变化过大"
                                        ></vxe-radio>
                                    </vxe-radio-group>
                                </div>

                                <!-- 正负列 -->
                                <div class="symbol-box">
                                    <span class="el-icon-plus"></span>
                                    <span class="el-icon-minus"></span>
                                </div>

                                <!-- 输入、选择 -->
                                <div class="input-box">
                                    <!-- 正  行内容 -->
                                    <div class="input-row flex">
                                        <vxe-checkbox
                                                v-model="checkObj.quantities.plusValue"
                                                :disabled="
                                                rules.quantities.type !== 1 ||
                                                mode === 'view'
                                            "
                                                @change="handleCheck($event, 'quantities', 'plusValue')"
                                        ></vxe-checkbox>
                                        <span>变化值</span>
                                        <vxe-input
                                                class="number-input"
                                                v-model.number="rules.quantities.plusValue"
                                                :disabled="inputDisabled('quantities', 'plusValue')"
                                                @input="onNumberInput($event, 'quantities', 'plusValue')"
                                                :min="0"
                                                type="number"
                                        ></vxe-input>
                                        <div class="switch-box">
                                            <vxe-radio-group v-model="rules.quantities.plusAlso"
                                                             :disabled="rules.quantities.type !== 1 || mode === 'view'">
                                                <vxe-radio
                                                        :label="0"
                                                        content="或"
                                                ></vxe-radio>
                                                <vxe-radio
                                                        :label="1"
                                                        content="且"
                                                ></vxe-radio>
                                            </vxe-radio-group>

                                        </div>
                                        <vxe-checkbox
                                                v-model="checkObj.quantities.plusRange"
                                                :disabled="
                                                rules.quantities.type !== 1 ||
                                                mode === 'view'
                                            "
                                                @change="handleCheck($event, 'quantities', 'plusRange')"
                                        ></vxe-checkbox>
                                        <span>变化幅度</span>
                                        <vxe-input
                                                class="number-input"
                                                v-model.number="rules.quantities.plusRange"
                                                :disabled="inputDisabled('quantities', 'plusRange')"
                                                @input="onNumberInput($event, 'quantities', 'plusRange')"
                                                :min="0"
                                                type="number"
                                        >
                                            <template #suffix>%</template>
                                        </vxe-input>
                                    </div>

                                    <!-- 负  行内容 -->
                                    <div class="input-row flex">
                                        <vxe-checkbox
                                                v-model="checkObj.quantities.minusValue"
                                                :disabled="
                                                rules.quantities.type !== 1 ||
                                                mode === 'view'
                                            "
                                                @change="handleCheck($event, 'quantities', 'minusValue')"
                                        ></vxe-checkbox>
                                        <span>变化值</span>
                                        <vxe-input
                                                class="number-input"
                                                v-model.number="rules.quantities.minusValue"
                                                :disabled="inputDisabled('quantities', 'minusValue')"
                                                @input="onNumberInput($event, 'quantities', 'minusValue')"
                                                :min="0"
                                                type="number"
                                        ></vxe-input>
                                        <div class="switch-box">
                                            <vxe-radio-group v-model="rules.quantities.minusAlso"
                                                             :disabled="rules.quantities.type !== 1 || mode === 'view'">
                                                <vxe-radio
                                                        :label="0"
                                                        content="或"
                                                ></vxe-radio>
                                                <vxe-radio
                                                        :label="1"
                                                        content="且"
                                                ></vxe-radio>
                                            </vxe-radio-group>
                                        </div>
                                        <vxe-checkbox
                                                v-model="checkObj.quantities.minusRange"
                                                :disabled="
                                                rules.quantities.type !== 1 ||
                                                mode === 'view'
                                            "
                                                @change="handleCheck($event, 'quantities', 'minusRange')"
                                        ></vxe-checkbox>
                                        <span>变化幅度</span>
                                        <vxe-input
                                                class="number-input"
                                                v-model.number="rules.quantities.minusRange"
                                                :disabled="inputDisabled('quantities', 'minusRange')"
                                                @input="onNumberInput($event, 'quantities', 'minusRange')"
                                                :min="0"
                                                type="number"
                                        >
                                            <template #suffix>%</template>
                                        </vxe-input>
                                    </div>
                                </div>
                            </div>
                        </template>
                        <!-- 清单单价 -->
                        <template v-if="row.order === 5">
                            <div class="flex-row">
                                <!-- 单项选择 -->
                                <div class="radio-box">
                                    <vxe-radio-group v-model="rules.perPrice.type" :disabled="mode === 'view'"
                                                     @change="handleChangeType($event, 'perPrice')">
                                        <vxe-radio
                                                :label="0"
                                                content="数值不一致"
                                        ></vxe-radio>
                                        <vxe-radio
                                                :label="1"
                                                content="数量变化过大"
                                        ></vxe-radio>
                                    </vxe-radio-group>
                                </div>

                                <!-- 正负列 -->
                                <div class="symbol-box">
                                    <span class="el-icon-plus"></span>
                                    <span class="el-icon-minus"></span>
                                </div>

                                <!-- 输入、选择 -->
                                <div class="input-box">
                                    <!-- 正  行内容 -->
                                    <div class="input-row flex">
                                        <vxe-checkbox
                                                v-model="checkObj.perPrice.plusValue"
                                                :disabled="
                                                rules.perPrice.type !== 1 ||
                                                mode === 'view'
                                            "
                                                @change="handleCheck($event, 'perPrice', 'plusValue')"
                                        ></vxe-checkbox>
                                        <span>变化值</span>
                                        <vxe-input
                                                class="number-input"
                                                v-model.number="rules.perPrice.plusValue"
                                                :disabled="inputDisabled('perPrice', 'plusValue')"
                                                @input="onNumberInput($event, 'perPrice', 'plusValue')"
                                                :min="0"
                                                type="number"
                                        ></vxe-input>
                                        <div class="switch-box">
                                            <vxe-radio-group v-model="rules.perPrice.plusAlso"
                                                             :disabled="rules.perPrice.type !== 1 || mode === 'view'">
                                                <vxe-radio
                                                        :label="0"
                                                        content="或"
                                                ></vxe-radio>
                                                <vxe-radio
                                                        :label="1"
                                                        content="且"
                                                ></vxe-radio>
                                            </vxe-radio-group>
                                        </div>
                                        <vxe-checkbox
                                                v-model="checkObj.perPrice.plusRange"
                                                :disabled="
                                                rules.perPrice.type !== 1 ||
                                                mode === 'view'
                                            "
                                                @change="handleCheck($event, 'perPrice', 'plusRange')"
                                        ></vxe-checkbox>
                                        <span>变化幅度</span>
                                        <vxe-input
                                                class="number-input"
                                                v-model.number="rules.perPrice.plusRange"
                                                :disabled="inputDisabled('perPrice', 'plusRange')"
                                                @input="onNumberInput($event, 'perPrice', 'plusRange')"
                                                :min="0"
                                                type="number"
                                        >
                                            <template #suffix>%</template>
                                        </vxe-input>
                                    </div>

                                    <!-- 负  行内容 -->
                                    <div class="input-row flex">
                                        <vxe-checkbox
                                                v-model="checkObj.perPrice.minusValue"
                                                :disabled="
                                                rules.perPrice.type !== 1 ||
                                                mode === 'view'
                                            "
                                                @change="handleCheck($event, 'perPrice', 'minusValue')"
                                        ></vxe-checkbox>
                                        <span>变化值</span>
                                        <vxe-input
                                                class="number-input"
                                                v-model.number="rules.perPrice.minusValue"
                                                :disabled="inputDisabled('perPrice', 'minusValue')"
                                                @input="onNumberInput($event, 'perPrice', 'minusValue')"
                                                :min="0"
                                                type="number"
                                        ></vxe-input>
                                        <div class="switch-box">
                                            <vxe-radio-group v-model="rules.perPrice.minusAlso"
                                                             :disabled="rules.perPrice.type !== 1 || mode === 'view'">
                                                <vxe-radio
                                                        :label="0"
                                                        content="或"
                                                ></vxe-radio>
                                                <vxe-radio
                                                        :label="1"
                                                        content="且"
                                                ></vxe-radio>
                                            </vxe-radio-group>
                                        </div>
                                        <vxe-checkbox
                                                v-model="checkObj.perPrice.minusRange"
                                                :disabled="
                                                rules.perPrice.type !== 1 ||
                                                mode === 'view'
                                            "
                                                @change="handleCheck($event, 'perPrice', 'minusRange')"
                                        ></vxe-checkbox>
                                        <span>变化幅度</span>
                                        <vxe-input
                                                class="number-input"
                                                v-model.number="rules.perPrice.minusRange"
                                                :disabled="inputDisabled('perPrice', 'minusRange')"
                                                @input="onNumberInput($event, 'perPrice', 'minusRange')"
                                                :min="0"
                                                type="number"
                                        >
                                            <template #suffix>%</template>
                                        </vxe-input>
                                    </div>
                                </div>
                            </div>
                        </template>
                        <!-- 清单合价 -->
                        <template v-if="row.order === 6">
                            <div class="flex-row">
                                <!-- 单项选择 -->
                                <div class="radio-box">
                                    <vxe-radio-group v-model="rules.totalPrice.type" :disabled="mode === 'view'"
                                                     @change="handleChangeType($event, 'totalPrice')">
                                        <vxe-radio
                                                :label="0"
                                                content="数值不一致"
                                        ></vxe-radio>
                                        <vxe-radio
                                                :label="1"
                                                content="数量变化过大"
                                        ></vxe-radio>
                                    </vxe-radio-group>
                                </div>

                                <!-- 正负列 -->
                                <div class="symbol-box">
                                    <span class="el-icon-plus"></span>
                                    <span class="el-icon-minus"></span>
                                </div>

                                <!-- 输入、选择 -->
                                <div class="input-box">
                                    <!-- 正  行内容 -->
                                    <div class="input-row flex">
                                        <vxe-checkbox
                                                v-model="checkObj.totalPrice.plusValue"
                                                :disabled="
                                                rules.totalPrice.type !== 1 ||
                                                mode === 'view'
                                            "
                                                @change="handleCheck($event, 'totalPrice', 'plusValue')"
                                        ></vxe-checkbox>
                                        <span>变化值</span>
                                        <vxe-input
                                                class="number-input"
                                                v-model.number="rules.totalPrice.plusValue"
                                                :disabled="inputDisabled('totalPrice', 'plusValue')"
                                                @input="onNumberInput($event, 'totalPrice', 'plusValue')"
                                                :min="0"
                                                type="number"
                                        ></vxe-input>
                                        <div class="switch-box">
                                            <vxe-radio-group v-model="rules.totalPrice.plusAlso"
                                                             :disabled="rules.totalPrice.type !== 1 || mode === 'view'">
                                                <vxe-radio
                                                        :label="0"
                                                        content="或"
                                                ></vxe-radio>
                                                <vxe-radio
                                                        :label="1"
                                                        content="且"
                                                ></vxe-radio>
                                            </vxe-radio-group>
                                        </div>
                                        <vxe-checkbox
                                                v-model="checkObj.totalPrice.plusRange"
                                                :disabled="
                                                rules.totalPrice.type !== 1 ||
                                                mode === 'view'
                                            "
                                                @change="handleCheck($event, 'totalPrice', 'plusRange')"
                                        ></vxe-checkbox>
                                        <span>变化幅度</span>
                                        <vxe-input
                                                class="number-input"
                                                v-model.number="rules.totalPrice.plusRange"
                                                :disabled="inputDisabled('totalPrice', 'plusRange')"
                                                @input="onNumberInput($event, 'totalPrice', 'plusRange')"
                                                :min="0"
                                                type="number"
                                        >
                                            <template #suffix>%</template>
                                        </vxe-input>
                                    </div>

                                    <!-- 负  行内容 -->
                                    <div class="input-row flex">
                                        <vxe-checkbox
                                                v-model="checkObj.totalPrice.minusValue"
                                                :disabled="
                                                rules.totalPrice.type !== 1 ||
                                                mode === 'view'
                                            "
                                                @change="handleCheck($event, 'totalPrice', 'minusValue')"
                                        ></vxe-checkbox>
                                        <span>变化值</span>
                                        <vxe-input
                                                class="number-input"
                                                v-model.number="rules.totalPrice.minusValue"
                                                :disabled="inputDisabled('totalPrice', 'minusValue')"
                                                @input="onNumberInput($event, 'totalPrice', 'minusValue')"
                                                :min="0"
                                                type="number"
                                        ></vxe-input>
                                        <div class="switch-box">
                                            <vxe-radio-group v-model="rules.totalPrice.minusAlso"
                                                             :disabled="rules.totalPrice.type !== 1 || mode === 'view'">
                                                <vxe-radio
                                                        :label="0"
                                                        content="或"
                                                ></vxe-radio>
                                                <vxe-radio
                                                        :label="1"
                                                        content="且"
                                                ></vxe-radio>
                                            </vxe-radio-group>
                                        </div>
                                        <vxe-checkbox
                                                v-model="checkObj.totalPrice.minusRange"
                                                :disabled="
                                                rules.totalPrice.type !== 1 ||
                                                mode === 'view'
                                            "
                                                @change="handleCheck($event, 'totalPrice', 'minusRange')"
                                        ></vxe-checkbox>
                                        <span>变化幅度</span>
                                        <vxe-input
                                                class="number-input"
                                                v-model.number="rules.totalPrice.minusRange"
                                                :disabled="inputDisabled('totalPrice', 'minusRange')"
                                                @input="onNumberInput($event, 'totalPrice', 'minusRange')"
                                                :min="0"
                                                type="number"
                                        >
                                            <template #suffix>%</template>
                                        </vxe-input>
                                    </div>
                                </div>
                            </div>
                        </template>
                    </template>
                </vxe-column>
            </vxe-table>
        </div>

        <!-- 单独保存时的弹窗 -->
        <el-dialog
                :visible.sync="dialogObj.visible"
                :title="dialogObj.title"
                :width="dialogObj.width"
                :close-on-click-modal="false"
                @closed="handleClose"
                top="30vh"
                append-to-body
        >
            <el-form
                    :model="addForm"
                    ref="addForm"
                    label-width="100px"
                    :show-message="false"
            >
                <el-form-item label="规则名称" required prop="sname">
                    <el-input
                            v-model="addForm.sname"
                            placeholder="请输入"
                            maxlength="50"
                            show-word-limit
                            @blur="onSnameBlur"
                    ></el-input>
                </el-form-item>
            </el-form>

            <!-- footer 组件 -->
            <div slot="footer" class="dialog-footer text-center">
                <el-button size="small" @click="dialogObj.visible = false"
                >取 消
                </el-button
                >
                <el-button
                        type="primary"
                        size="small"
                        :loading="dialogObj.btnLoading"
                        @click="doSave"
                >确 定
                </el-button
                >
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import {saveOrUpdateRule, ruleTools} from "@/api/modules/rule_setting.js";
    import {getRulesList} from "@/api/modules/clearSection.js";

    export default {
        props: {
            // 当前模式
            mode: {
                type: String,
                default: "add",
            },
            // 当前模式
            isSys: {
                type: String,
                default: "",
            },
            // 当前是否需要显示右上角保存
            needSave: {
                type: Boolean,
                default: false,
            },
            // 自动分析导出
            showTools: {
                type: Boolean,
                default: true,
            }
        },
        data() {
            return {
                tableLoading: false,
                tableData: [
                    {
                        title: "清单项目名称",
                        order: 1,
                    },
                    {
                        title: "清单项目特征",
                        order: 2,
                    },
                    {
                        title: "清单计量单位",
                        order: 3,
                    },
                    {
                        title: "清单工程量",
                        order: 4,
                    },
                    {
                        title: "清单单价",
                        order: 5,
                    },
                    {
                        title: "清单合价",
                        order: 6,
                    },
                ],
                rules: {
                    sname: 1, // 名称是否一致
                    feature: 1, // 特征是否一致
                    unit: 1, // 单位是否一致
                    quantities: {
                        type: "", // 0 数值不一样 1 数量变化大
                        plusAlso: 0, // 是否同时满足
                        minusAlso: 0, // 是否同时满足
                        plusRange: "", // 变化幅度正值
                        minusRange: "", // 变化幅度负值
                        plusValue: "", // 变化值正值
                        minusValue: "", // 变化值负值
                    },
                    // 清单单价
                    perPrice: {
                        type: "", // 0 数值不一样 1 数量变化大
                        plusAlso: 0, // 是否同时满足
                        minusAlso: 0, // 是否同时满足
                        plusRange: "", // 变化幅度正值
                        minusRange: "", // 变化幅度负值
                        plusValue: "", // 变化值正值
                        minusValue: "", // 变化值负值
                    },
                    // 清单合价
                    totalPrice: {
                        type: "", // 0 数值不一样 1 数量变化大
                        plusAlso: 0, // 是否同时满足
                        minusAlso: 0, // 是否同时满足
                        plusRange: "", // 变化幅度正值
                        minusRange: "", // 变化幅度负值
                        plusValue: "", // 变化值正值
                        minusValue: "", // 变化值负值
                    },
                },
                checkObj: {
                    quantities: {
                        plusValue: false,
                        minusValue: false,
                        plusRange: false,
                        minusRange: false,
                    },
                    perPrice: {
                        plusValue: false,
                        minusValue: false,
                        plusRange: false,
                        minusRange: false,
                    },
                    totalPrice: {
                        plusValue: false,
                        minusValue: false,
                        plusRange: false,
                        minusRange: false,
                    },
                },
                // 带保存时的一些参数----------
                curRule: '',
                ruleObj: {},
                rulesList: [],
                // 弹窗
                dialogObj: {
                    title: "我的分析规则",
                    visible: false,
                    width: "1200px",
                    mode: "add",
                    btnLoading: false,
                },
                // 新增规则
                addForm: {
                    sname: "",
                    id: "",
                    rules: {},
                },
            };
        },
        created() {
            // 如果是 带保存的
            if (this.needSave) {
                this.getRules();
            }

            if (!this.showTools) {
                this.tableLoading = true
            }
        },
        methods: {
            // 获取全部生效的规则
            getRules(id) {
                let param = {};
                param.isSys = this.isSys;
                getRulesList(param)
                    .then((res) => {
                        // 自动分析 不加载临时规则
                        this.rulesList = this.showTools ? res.data : res.data.filter(x => x.isTemp !== 1);
                        // 如果有id 加载id 那条规则
                        let _item = res.data.find((x) => x.id === id);
                        if (_item) {
                            this.ruleObj = _item
                            this.curRule = _item.id;
                            this.onChangeRule(this.curRule);
                            return;
                        }

                        // 加载 系统默认规则
                        let _default = res.data.find((x) => x.isDefault === 1);
                        if (_default) {
                            this.ruleObj = _default
                            this.curRule = _default.id;
                            this.onChangeRule(this.curRule);
                        }
                    })
                    .catch((err) => {
                        this.rulesList = [];
                    });
            },

            // 清空该行规则
            doClear(order) {
                switch (order) {
                    // 清单名称
                    case 1:
                        this.rules.sname = "";
                        break;
                    // 特征
                    case 1:
                        this.rules.feature = "";
                        break;
                    // 单位
                    case 1:
                        this.rules.unit = "";
                        break;
                    // 清单工程量
                    case 4:
                        this.rules.quantities.type = "";
                        this.rules.quantities.plusAlso = "";
                        this.rules.quantities.minusAlso = "";
                        this.rules.quantities.plusRange = "";
                        this.rules.quantities.minusRange = "";
                        this.rules.quantities.plusValue = "";
                        this.rules.quantities.minusValue = "";
                        break;
                    // 清单单价
                    case 5:
                        this.rules.perPrice.type = "";
                        this.rules.quantities.plusAlso = "";
                        this.rules.quantities.minusAlso = "";
                        this.rules.perPrice.plusRange = "";
                        this.rules.perPrice.minusRange = "";
                        this.rules.perPrice.plusValue = "";
                        this.rules.perPrice.minusValue = "";
                        break;
                    // 清单合价
                    case 6:
                        this.rules.totalPrice.type = "";
                        this.rules.quantities.plusAlso = "";
                        this.rules.quantities.minusAlso = "";
                        this.rules.totalPrice.plusRange = "";
                        this.rules.totalPrice.minusRange = "";
                        this.rules.totalPrice.plusValue = "";
                        this.rules.totalPrice.minusValue = "";
                        break;
                }
            },

            // 输入框是否可填写
            inputDisabled(type, value) {
                let _con1 = this.checkObj[type][value]
                let _con3 = this.mode === 'view'
                return _con3 || !_con1
            },

            // 数值输入事件  不允许输入负数
            onNumberInput(val, type, value) {
                this.rules[type][value] = parseFloat(val.replace(/\-/g, '')) || 0
            },

            // 异常条件类型切换
            handleChangeType(obj, type) {
                if (obj.label === 1) {
                    // 默认选中第一个
                    this.checkObj[type].plusValue = true

                    // 值的处理
                    this.rules[type].plusValue = 0
                    this.rules[type].plusAlso = 0
                    this.rules[type].minusAlso = 0
                } else {
                    this.checkObj[type].plusValue = false

                    // 值的处理
                    this.rules[type].plusValue = ''
                    this.rules[type].minusValue = ''
                    this.rules[type].plusRange = ''
                    this.rules[type].minusRange = ''

                    this.rules[type].plusAlso = ''
                    this.rules[type].minusAlso = ''
                }

                this.checkObj[type].minusValue = false
                this.checkObj[type].plusRange = false
                this.checkObj[type].minusRange = false
            },

            // 复选框选中时 数据
            handleCheck(obj, type, value) {
                this.rules[type][value] = obj.checked ? 0 : ''
            },

            // 规则切换
            onChangeRule(val) {
                let item = this.rulesList.find((x) => x.id === val);
                if (item) {
                    this.ruleObj = item
                    this.rules = this.$utils.clone(item.rules, true);

                    // 选中checkbox
                    this.setChecked()
                }
            },

            // 回显时 选中复选框
            setChecked() {
                // 数量
                this.checkObj.quantities.plusValue = this.rules.quantities.plusValue !== ''
                this.checkObj.quantities.minusValue = this.rules.quantities.minusValue !== ''
                this.checkObj.quantities.plusRange = this.rules.quantities.plusRange !== ''
                this.checkObj.quantities.minusRange = this.rules.quantities.minusRange !== ''

                // 单价
                this.checkObj.perPrice.plusValue = this.rules.perPrice.plusValue !== ''
                this.checkObj.perPrice.minusValue = this.rules.perPrice.minusValue !== ''
                this.checkObj.perPrice.plusRange = this.rules.perPrice.plusRange !== ''
                this.checkObj.perPrice.minusRange = this.rules.perPrice.minusRange !== ''

                // 总价
                this.checkObj.totalPrice.plusValue = this.rules.totalPrice.plusValue !== ''
                this.checkObj.totalPrice.minusValue = this.rules.totalPrice.minusValue !== ''
                this.checkObj.totalPrice.plusRange = this.rules.totalPrice.plusRange !== ''
                this.checkObj.totalPrice.minusRange = this.rules.totalPrice.minusRange !== ''
            },

            // 点击右上角保存按钮
            onClickSave() {
                this.dialogObj.visible = true;
            },

            // 点击右上角删除按钮
            onClickDelete() {
                let params = {
                    type: 1,
                    id: this.curRule,
                };

                this.$confirm("确认要删除当前数据吗？", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                })
                    .then(() => {
                        ruleTools(params)
                            .then((res) => {
                                this.$message.success('删除成功！');

                                // 重载规则
                                this.getRules()
                            })
                            .catch((err) => {
                            });
                    })
                    .catch(() => {
                        return
                    });
            },

            // 弹窗关闭事件
            handleClose() {
                // 参数对象
                this.addForm.id = "";
                this.addForm.sname = "";
                this.addForm.rules = {};
            },

            // 规则名称失焦事件
            onSnameBlur() {
                this.addForm.sname = this.addForm.sname.replace(/\s+/g, "");
            },

            // 检查保存时 是否填写了
            checkSave() {
                return new Promise((resolve) => {
                    // 清单工程量
                    let isEmpty =
                        this.rules.quantities.plusRange === "" &&
                        this.rules.quantities.minusRange === "" &&
                        this.rules.quantities.plusValue === "" &&
                        this.rules.quantities.minusValue === "";
                    if (this.rules.quantities.type === 1 && isEmpty) {
                        this.$message.warning("请将清单工程量的异常条件 至少填写一个！");
                        resolve(false);
                        return;
                    }

                    // 清单单价
                    let isEmpty2 =
                        this.rules.perPrice.plusRange === "" &&
                        this.rules.perPrice.minusRange === "" &&
                        this.rules.perPrice.plusValue === "" &&
                        this.rules.perPrice.minusValue === "";
                    if (this.rules.perPrice.type === 1 && isEmpty2) {
                        this.$message.warning("请将清单单价的异常条件 至少填写一个！");
                        resolve(false);
                        return;
                    }

                    // 清单合价
                    let isEmpty3 =
                        this.rules.totalPrice.plusRange === "" &&
                        this.rules.totalPrice.minusRange === "" &&
                        this.rules.totalPrice.plusValue === "" &&
                        this.rules.totalPrice.minusValue === "";
                    if (this.rules.totalPrice.type === 1 && isEmpty3) {
                        this.$message.warning("请将清单合价的异常条件 至少填写一个！");
                        resolve(false);
                        return;
                    }

                    resolve(true);
                    return;
                });
            },

            // 最终保存规则并切换到最新规则
            doSave() {
                this.dialogObj.btnLoading = true;
                let params = {
                    id: "",
                    sname: this.addForm.sname,
                    rules: undefined,
                    isSys: this.isSys,
                };
                params.rules = this.$utils.clone(this.rules, true);

                this.$refs.addForm.validate((valid) => {
                    if (valid) {
                        // 接口保存
                        saveOrUpdateRule(params)
                            .then((res) => {
                                this.dialogObj.btnLoading = false;
                                this.dialogObj.visible = false;
                                // 重载规则
                                this.getRules(res.data.id);
                            })
                            .catch((err) => {
                                setTimeout(() => {
                                    this.dialogObj.btnLoading = false;
                                }, 2000);
                            });
                    } else {
                        setTimeout(() => {
                            this.dialogObj.btnLoading = false;
                        }, 2000);
                    }
                });
            },
        },
        watch: {
            // 当异常条件选择 变化时， 四个条件必须至少选一个
            'checkObj.quantities': {
                handler: function (obj) {
                    let arr = Object.values(obj)
                    // 当是在变化值条件下  且没有选中时
                    if (!arr.find(x => x === true) && this.rules.quantities.type === 1) {
                        this.$message.warning('至少选择一个变化选项！')
                        setTimeout(() => {
                            this.$set(this.checkObj.quantities, 'plusValue', true)
                            this.$set(this.rules.quantities, 'plusValue', 0)
                        }, 500)
                    }
                },
                deep: true
            },

            // 当异常条件选择 变化时， 四个条件必须至少选一个
            'checkObj.perPrice': {
                handler: function (obj) {
                    let arr = Object.values(obj)
                    // 当是在变化值条件下  且没有选中时
                    if (!arr.find(x => x === true) && this.rules.perPrice.type === 1) {
                        this.$message.warning('至少选择一个变化选项！')
                        setTimeout(() => {
                            this.$set(this.checkObj.perPrice, 'plusValue', true)
                            this.$set(this.rules.perPrice, 'plusValue', 0)
                        }, 500)
                    }
                },
                deep: true
            },

            // 当异常条件选择 变化时， 四个条件必须至少选一个
            'checkObj.totalPrice': {
                handler: function (obj) {
                    let arr = Object.values(obj)
                    // 当是在变化值条件下  且没有选中时
                    if (!arr.find(x => x === true) && this.rules.totalPrice.type === 1) {
                        this.$message.warning('至少选择一个变化选项！')
                        setTimeout(() => {
                            this.$set(this.checkObj.totalPrice, 'plusValue', true)
                            this.$set(this.rules.totalPrice, 'plusValue', 0)
                        }, 500)
                    }
                },
                deep: true
            }
        }
    };
</script>

<style scoped lang="less">
    .flex-row {
        display: flex;
        height: 90px;
        @borderColor: #ccc;

        .radio-box {
            width: 230px;
            flex-shrink: 0;
            text-align: left;
            line-height: 76px;
        }

        .symbol-box {
            width: 45px;
            line-height: 41px;
            border: 1px solid @borderColor;
            flex-shrink: 0;

            span {
                display: inline-block;
                width: 100%;
                height: 50%;
                line-height: 44px;
                text-align: center;
            }

            span:nth-of-type(1) {
                border-bottom: 1px solid @borderColor;
            }
        }

        .switch-box {
            width: 100px;
            flex-shrink: 0;
            text-align: center;
            margin: 0 auto;
        }

        .input-box {
            border: 1px solid @borderColor;
            border-left: none;
            width: 100%;

            .input-row {
                display: flex;
                height: 50%;
                align-items: center;
                padding: 0 10px;
            }

            .input-row:nth-of-type(1) {
                border-bottom: 1px solid @borderColor;
            }

            .number-input {
                width: 100px;
                margin-left: 10px;
            }
        }
    }
</style>
